import React from 'react';
import { useTranslation } from '@/hooks/useTranslation';
import { BarChart4, Euro, Users, ClipboardList, Calendar, FileText } from 'lucide-react';

const ProofSection = () => {
  const { t } = useTranslation();
  
  return (
    <section id="proof" className="py-16 md:py-24 bg-gradient-to-br from-blue-50 to-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-blue-900">
            Entdecke unbegrenzte Möglichkeiten für dein Unternehmen
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto mb-8">
            Einfache Business-Anwendungen, die jeder Geschäftsführer braucht - "Das hätte ich schon längst haben sollen!"
          </p>
        </div>
        
        {/* Applikationsbeispiele */}
        <div className="max-w-5xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100 hover:shadow-md transition-shadow">
              <div className="bg-blue-100 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                <BarChart4 className="h-6 w-6 text-blue-700" />
              </div>
              <h4 className="text-lg font-semibold mb-3 text-blue-900">Geschäftsführer-Dashboard</h4>
              <p className="text-gray-600 text-sm">
                Alle wichtigen Zahlen auf einen Blick: Umsatz, offene Rechnungen, Liquidität, Top-Kunden. Endlich weißt du immer, wie dein Unternehmen steht.
              </p>
            </div>
            
            <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100 hover:shadow-md transition-shadow">
              <div className="bg-blue-100 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                <Euro className="h-6 w-6 text-blue-700" />
              </div>
              <h4 className="text-lg font-semibold mb-3 text-blue-900">Angebots- & Rechnungstool</h4>
              <p className="text-gray-600 text-sm">
                Professionelle Angebote in 2 Minuten erstellen, automatisch in Rechnungen umwandeln. Schluss mit Word-Vorlagen und Excel-Listen.
              </p>
            </div>
            
            <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100 hover:shadow-md transition-shadow">
              <div className="bg-blue-100 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                <Users className="h-6 w-6 text-blue-700" />
              </div>
              <h4 className="text-lg font-semibold mb-3 text-blue-900">Einfaches Kunden-CRM</h4>
              <p className="text-gray-600 text-sm">
                Alle Kundenkontakte, Termine und Notizen an einem Ort. Nie wieder vergessene Nachfass-Termine oder verlorene Kundeninformationen.
              </p>
            </div>
            
            <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100 hover:shadow-md transition-shadow">
              <div className="bg-blue-100 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                <ClipboardList className="h-6 w-6 text-blue-700" />
              </div>
              <h4 className="text-lg font-semibold mb-3 text-blue-900">Aufgaben & Projekte</h4>
              <p className="text-gray-600 text-sm">
                Behalte den Überblick über alle Aufgaben und Projekte. Wer macht was bis wann? Einfache Planung ohne komplizierte Software.
              </p>
            </div>
            
            <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100 hover:shadow-md transition-shadow">
              <div className="bg-blue-100 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                <Calendar className="h-6 w-6 text-blue-700" />
              </div>
              <h4 className="text-lg font-semibold mb-3 text-blue-900">Termin- & Ressourcenplanung</h4>
              <p className="text-gray-600 text-sm">
                Mitarbeiter, Räume und Fahrzeuge optimal planen. Doppelbuchungen vermeiden, Auslastung maximieren - alles in einer Übersicht.
              </p>
            </div>
            
            <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100 hover:shadow-md transition-shadow">
              <div className="bg-blue-100 rounded-full w-12 h-12 flex items-center justify-center mb-4">
                <FileText className="h-6 w-6 text-blue-700" />
              </div>
              <h4 className="text-lg font-semibold mb-3 text-blue-900">Digitale Ablage</h4>
              <p className="text-gray-600 text-sm">
                Alle wichtigen Dokumente digital und sofort findbar. Verträge, Rechnungen, Zertifikate - nie wieder stundenlang suchen.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProofSection; 